import { createActions, createReducer } from 'reduxsauce';
import * as Immutable from 'seamless-immutable';
import * as R from 'ramda';

/* ------------- Types and Action Creators ------------- */
const tag = '[SAGA_OFFER_REDUX]'; // eslint-disable-line

const functionDefinitions = {

  /*---------- getDeedDetail --------*/

  requestGetDeedDetail: ['contractId', 'deedId', 'userId'],
  getDeedDetailSuccess: ['getDeedDetailResponse'],
  getDeedDetailFailure: ['getDeedDetailError'],
  requestUpdateFinancialStatement: ['financialStatement'],

  /*---------- updateDeedPayment --------*/

  requestUpdateDeedPayment: ['deedPaymentBreakDown'],
  updateDeedPaymentSuccess: ['updateDeedPaymentResponse'],
  updateDeedPaymentFailure: ['updateDeedPaymentError'],


  /*---------- updateDeedDetail --------*/

  requestUpdateDeedDetail: ['deedDetail', 'userId', 'offerId'],
  updateDeedDetailSuccess: ['updateDeedDetailResponse'],
  updateDeedDetailFailure: ['updateDeedDetailError'],


  /*---------- updateDeedDescription --------*/

  requestUpdateDeedDescription: ['deed'],
  updateDeedDescriptionSuccess: ['updateDeedDescriptionResponse'],
  updateDeedDescriptionFailure: ['updateDeedDescriptionError'],

  /*---------- generateDeedReport --------*/

  requestGenerateDeedReport: ['deedId'],
  generateDeedReportSuccess: ['generateDeedReportResponse'],
  generateDeedReportFailure: ['generateDeedReportError'],

  /*---------- restoreDeed --------*/
  requestRestoreDeed: ['historyId', 'offerId', 'contractId', 'action', 'actionId', 'propertyId', 'deedId'],
  restoreDeedSuccess: ['restoreDeedResponse'],
  restoreDeedFailure: ['restoreDeedError'],

};


const { Types, Creators } = createActions(functionDefinitions);

export const SagaDeedTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */

export const SagaDeedInitState = {
  deedDetail: [],
};

export const INITIAL_STATE = Immutable(SagaDeedInitState);

/* ------------- Reducers ------------- */

/*---------- getDeedDetail --------*/


export const requestGetDeedDetail = (state, action) => {
  return state.merge(
    {
      getDeedDetailFetching: true,
      contractId: action.contractId,
      deedId: action.deedId,
      generateDeedReportResponse: null,
      getDeedDetailError: null,
    });
};
export const getDeedDetailSuccess = (state, action) => {
  return state.merge(
    {
      getDeedDetailFetching: false,
      getDeedDetailResponse: action.getDeedDetailResponse,

    });
};
export const getDeedDetailFailure = (state, action) => {
  return state.merge(
    {
      getDeedDetailFetching: false,
      getDeedDetailError: action.getDeedDetailError,

    });
};

export const requestUpdateFinancialStatement = (state, action) => {
  const getDeedDetailResponse = { ...state.getDeedDetailResponse };
  getDeedDetailResponse.financialStatement = action.financialStatement;
  return state.merge(
    {
      getDeedDetailResponse
    });
};


/*---------- updateDeedPayment --------*/


export const requestUpdateDeedPayment = (state, action) => {
  return state.merge(
    {
      updateDeedPaymentFetching: true,
      deedPaymentBreakDown: action.deedPaymentBreakDown,
      updateDeedPaymentError: null,
    });
};
export const updateDeedPaymentSuccess = (state, action) => {
  return state.merge(
    {
      updateDeedPaymentFetching: false,
      updateDeedPaymentResponse: action.updateDeedPaymentResponse,
      updateDeedPaymentError: null,
      getDeedDetailResponse: action.updateDeedPaymentResponse
    });
};
export const updateDeedPaymentFailure = (state, action) => {
  return state.merge(
    {
      updateDeedPaymentFetching: false,
      updateDeedPaymentError: action.updateDeedPaymentError,

    });
};


/*---------- updateDeedDetail --------*/


export const requestUpdateDeedDetail = (state, action) => {
  return state.merge(
    {
      updateDeedDetailFetching: true,
      deedDetail: action.deedDetail,
      updateDeedDetailError: null,
      offerId: action.offerId,
    });
};
export const updateDeedDetailSuccess = (state, action) => {
  return state.merge(
    {
      updateDeedDetailFetching: false,
      updateDeedDetailResponse: action.updateDeedDetailResponse,
      updateDeedDetailError: null,

    });
};
export const updateDeedDetailFailure = (state, action) => {
  return state.merge(
    {
      updateDeedDetailFetching: false,
      updateDeedDetailError: action.updateDeedDetailError,

    });
};


/*---------- updateDeedDescription --------*/


export const requestUpdateDeedDescription = (state, action) => {
  return state.merge(
    {
      updateDeedDescriptionFetching: true,
      deed: action.deed,
      updateDeedDescriptionError: null,

    });
};
export const updateDeedDescriptionSuccess = (state, action) => {
  return state.merge(
    {
      updateDeedDescriptionFetching: false,
      updateDeedDescriptionResponse: action.updateDeedDescriptionResponse,
      updateDeedDescriptionError: null,

    });
};
export const updateDeedDescriptionFailure = (state, action) => {
  return state.merge(
    {
      updateDeedDescriptionFetching: false,
      updateDeedDescriptionError: action.updateDeedDescriptionError,

    });
};


/*---------- generateDeedReport --------*/


export const requestGenerateDeedReport = (state, action) => {
  return state.merge(
    {
      generateDeedReportFetching: true,
      deedId: action.deedId,
      generateDeedReportError: null,
      generateDeedReportResponse: null
    });
};
export const generateDeedReportSuccess = (state, action) => {
  return state.merge(
    {
      generateDeedReportFetching: false,
      generateDeedReportResponse: action.generateDeedReportResponse,
      generateDeedReportError: null

    });
};
export const generateDeedReportFailure = (state, action) => {
  return state.merge(
    {
      generateDeedReportFetching: false,
      generateDeedReportError: action.generateDeedReportError,

    });
};

/*---------- restoreDeed --------*/
export const requestRestoreDeed = (state, action) => {
  return state.merge(
    {
      restoreDeedFetching: true,
      restoreDeedResponse: null,
      restoreDeedError: null,
      historyId: action.historyId,
      offerId: action.offerId,
      contractId: action.contractId,
      action: action.action,
      actionId: action.actionId,
      propertyId: action.propertyId,
      deedId: action.deedId,
    });
};
export const restoreDeedSuccess = (state, action) => {
  return state.merge(
    {
      restoreDeedFetching: false,
      restoreDeedResponse: action.restoreDeedResponse,
    });
};
export const restoreDeedFailure = (state, action) => {
  return state.merge(
    {
      restoreDeedFetching: false,
      restoreDeedError: action.restoreDeedError,
    });
};


/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  /*---------- getDeedDetail --------*/

  [Types.REQUEST_GET_DEED_DETAIL]: requestGetDeedDetail,
  [Types.GET_DEED_DETAIL_SUCCESS]: getDeedDetailSuccess,
  [Types.GET_DEED_DETAIL_FAILURE]: getDeedDetailFailure,
  [Types.REQUEST_UPDATE_FINANCIAL_STATEMENT]: requestUpdateFinancialStatement,

  /*---------- updateDeedPayment --------*/

  [Types.REQUEST_UPDATE_DEED_PAYMENT]: requestUpdateDeedPayment,
  [Types.UPDATE_DEED_PAYMENT_SUCCESS]: updateDeedPaymentSuccess,
  [Types.UPDATE_DEED_PAYMENT_FAILURE]: updateDeedPaymentFailure,

  /*---------- updateDeedDetail --------*/

  [Types.REQUEST_UPDATE_DEED_DETAIL]: requestUpdateDeedDetail,
  [Types.UPDATE_DEED_DETAIL_SUCCESS]: updateDeedDetailSuccess,
  [Types.UPDATE_DEED_DETAIL_FAILURE]: updateDeedDetailFailure,


  /*---------- updateDeedDescription --------*/

  [Types.REQUEST_UPDATE_DEED_DESCRIPTION]: requestUpdateDeedDescription,
  [Types.UPDATE_DEED_DESCRIPTION_SUCCESS]: updateDeedDescriptionSuccess,
  [Types.UPDATE_DEED_DESCRIPTION_FAILURE]: updateDeedDescriptionFailure,


  /*---------- generateDeedReport --------*/

  [Types.REQUEST_GENERATE_DEED_REPORT]: requestGenerateDeedReport,
  [Types.GENERATE_DEED_REPORT_SUCCESS]: generateDeedReportSuccess,
  [Types.GENERATE_DEED_REPORT_FAILURE]: generateDeedReportFailure,

  /*---------- restoreDeed --------*/
  [Types.REQUEST_RESTORE_DEED]: requestRestoreDeed,
  [Types.RESTORE_DEED_SUCCESS]: restoreDeedSuccess,
  [Types.RESTORE_DEED_FAILURE]: restoreDeedFailure,


});


// WEBPACK FOOTER //
// ./src/redux/sagaDeed/sagaDeedRedux.ts